export const schema_default1 = {
  title: "",
  type: "object",
  required: [
    "usercount",
    "username",
    "userType"
  ],
  properties: {
    usercount: {
      type: "integer",
      title: "Number of users"
    },
    username: {
      type: "string",
      title: "Username starts with"
    },
    userType: {
      type: "number",
      title: "User Type",
      enum: [
        3,
        2
      ],
      enumNames: [
        "Field Work Partner",
        "Project Manager"
      ],
      default: 3
    },
    group: {
      type: "number",
      title: "Group",
      enum: [],
      enumNames: []
    }
  }
}

export const schema_default = {
    title: "",
    type: "object",
    required: [
        "usercount",
        "username",
        "userType",
        "group"
    ],
    properties: {
        usercount: {
          type: "integer",
          title: "Number of users"
        },
        username: {
          type: "string",
          title: "Username starts with"
        },
        userType: {
          type: "number",
          title: "User Type",
          enum: [
            3,
            2
          ],
          enumNames: [
            "Field Work Partner",
            "Project Manager"
          ],
          default: 3
        },
        group: {
            title: "Group",
            type: "number",
            enumNames: [
                "New Group",
                "Existing Group"
            ],
            enum: [
                0, 1
            ],
        default: 0
        }
    },
    dependencies: {
        group: {
          oneOf: [
            {
                properties: {
                    group: {
                    enum: [
                        0
                    ],
                    enumNames: [
                        "New Group"
                    ]
                },
                new_group: {
                    title: "New group name",
                    type: "string"
                }
              }
            },
            {
                properties: {
                    group: {
                        title: "Group",
                        enum: [
                            1
                        ],
                        enumNames: [
                            "Existing Group"
                        ]
                },
                existing_group: {
                    title: "Existing Group",
                    type: "number",
                }
              }
            }
          ]
        }
    }
}

export const uiSchema = {
  group: {
    "ui:widget": "radio",
    "ui:enumDisabled": [1]
  }
}


// WEBPACK FOOTER //
// ./src/views/users/constants.js